import { SectionId } from '@wix/wix-help-widget-common/homepage';
import { InfoCircle } from '@wix/wix-ui-icons-common';
import { useMemo } from 'react';

import { ChatbotButton } from './ChatbotButton';
import { ChatWithUs } from './ChatWithUs';
import { ExternalResources } from './ExternalResources';
import { HelpCenterButton } from './HelpCenterButton';
import { HireProfessional } from './HireProfessional';
import { RecommendedArticles } from './RecommendedArticles';
import { RequestSuccessManager } from './RequestSuccessManager';
import { ShareFeedback } from './ShareFeedback';
import { StatusPage } from './StatusPage';
import { HomepageSectionData } from './types';
import { UserContacts } from './UserContacts';

export const useMapSectionIdToSectionData: () => Record<
  SectionId,
  HomepageSectionData
> = () => {
  return useMemo(
    () => ({
      [SectionId.Articles]: {
        titleKey: 'home_your_recommended_articles',
        SectionComponent: RecommendedArticles,
      },
      [SectionId.HelpCenter]: {
        titleKey: 'home_browse_all_help_topics',
        SectionComponent: HelpCenterButton,
      },
      [SectionId.Resources]: {
        titleKey: 'home_explore_more_resources',
        titleIcon: {
          tooltipKey: 'home_explore_more_resources_tooltip_content',
          Icon: InfoCircle,
        },
        SectionComponent: ExternalResources,
      },
      [SectionId.HirePartner]: {
        titleKey: 'home_hire_a_professional',
        SectionComponent: HireProfessional,
      },
      [SectionId.ContactUs]: {
        SectionComponent: ChatbotButton,
      },
      [SectionId.StatusPage]: {
        SectionComponent: StatusPage,
      },
      [SectionId.ChatWithUs]: {
        titleKey: 'home_chat_with_us_title',
        SectionComponent: ChatWithUs,
      },
      [SectionId.UserContacts]: {
        titleKey: 'home_contact_partner_success_team',
        SectionComponent: UserContacts,
      },
      [SectionId.RequestSuccessManager]: {
        titleKey: 'home_request_success_manager',
        SectionComponent: RequestSuccessManager,
      },
      [SectionId.ShareFeedback]: {
        titleKey: 'share_your_feedback',
        SectionComponent: ShareFeedback,
      },
    }),
    [],
  );
};
